import { AnimationConfigWithPath } from 'lottie-web';

export const defaultLottieOptions: Omit<AnimationConfigWithPath, 'container'> = {
  renderer: 'svg',
  loop: true,
  autoplay: true,
};
